<template>
  <div class="page feedback">
    <h1>Feedback</h1>
    <div class="page__content">
      <Loader v-if="isLoading"></Loader>
      <div class="feedback__results" v-else>
        <table class="table" v-if="feedback.length">
          <thead>
          <tr class="table__header">
            <th class="table__header__column">ID</th>
            <th class="table__header__column">Link dispatch</th>
            <th class="table__header__column">Datum</th>
            <th class="table__header__column" v-if="isOA">Chauffeur</th>
            <th class="table__header__column">Passagier</th>
            <th class="table__header__column">Feedback</th>
            <th class="table__header__column">Score</th>
          </tr>
          </thead>
          <tbody class="table__body" id="results">
          <tr class="table__body__item" :class="{'table__body__item--edited':item.feedbackscorechauffeur===2,'table__body__item--error':item.feedbackscorechauffeur<=1}" v-for="item in feedback" :key="`feedback--${item.id}`">
            <td class="table__body__item__column">{{item.id}}</td>
            <td class="table__body__item__column">{{item.linkdispatch}}</td>
            <td class="table__body__item__column">{{item.dedatum}}</td>
            <td class="table__body__item__column" v-if="isOA">{{item.chauffeurOA}}</td>
            <td class="table__body__item__column">{{item.passagier}}</td>
            <td class="table__body__item__column">{{item.feedbackchauffeur}}</td>
            <td class="table__body__item__column"><Stars :score="item.feedbackscorechauffeur/4*100"></Stars></td>
          </tr>
          </tbody>
        </table>
        <p v-else>Nog geen feedback verkregen.</p>
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackService from "@/services/feedback";
import Loader from "@/components/Loader";
import Stars from "@/components/Stars";

export default {
  name: "Feedback",
  components: {Loader,Stars},
  data() {
    return {
      isLoading: false,
      feedback: []
    };
  },
  created() {
    this.fetchFeedback();
  },

  computed: {
    isOA() {
      return parseInt(this.$store.state.auth.user.BEDRIJF) === 8;
    }
  },

  methods: {
    fetchFeedback() {
      this.isLoading = true;
      FeedbackService.getFeedback(this.$store.state.auth.user.PERS_ID)
        .then(res => {
          if (res.status && res.data) {
            this.feedback = res.data;
          }
          this.isLoading = false;
        })
    }
  }
}
</script>
